// ======================================================================
// File Name       : item
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/item';

export function receiveItemList(apiRes, startPosition) {
  const { recordNum, itemList } = apiRes;
  return {
    type: ActionTypes.ITEM_RECEIVE_ITEM_LIST,
    startPosition,
    recordNum,
    itemList,
  };
}

export function initDataForDetailEditConfirmDialog(itemSecernId, isItemReport) {
  return {
    type: ActionTypes.ITEM_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG,
    itemSecernId,
    isItemReport,
  };
}

export function initDataForRegisterContentLinkingDialog(payload) {
  return {
    type: ActionTypes.ITEM_INIT_DATA_FOR_REGISTER_DIALOG,
    payload,
  };
}

export function receiveLinkingContent(contentInfo) {
  return {
    type: ActionTypes.ITEM_RECIEVE_LINKING_CONTENT,
    contentInfo,
  };
}

export function updateItem(payload) {
  return {
    type: ActionTypes.ITEM_UPDATE,
    payload,
  };
}

export function changeData(data) {
  return {
    type: ActionTypes.ITEM_CHANGE_DATA,
    data,
  };
}

export function getThumbnailDefault(data) {
  return {
    type: ActionTypes.ITEM_GET_THUMBNAIL_DEFAULT,
    data,
  };
}

export function getVideoThumbnailDefault(data) {
  return {
    type: ActionTypes.ITEM_GET_VIDEO_THUMBNAIL_DEFAULT,
    data,
  };
}

export function getDocumentThumbnailDefault(data) {
  return {
    type: ActionTypes.ITEM_GET_DOCUMENT_THUMBNAIL_DEFAULT,
    data,
  };
}

export function saveDetailSettingState(name, value) {
  return {
    type: ActionTypes.ITEM_SAVE_DETAIL_SETTING_STATE,
    name,
    value,
  };
}
